import Exim from 'exim';
import _ from 'lodash';
import lazy from './lazy-loader';

const LookupsAPI = {
  loadAll() {
    return lazy('/api/lookups/all');
  },

  resetCache() {
    lazy.clear('/api/lookups/all');
    return lazy('/api/lookups/all');
  },

  get(lookup) {
    return this.loadAll().then(function (res) {
      lookup = lookup.toUpperCase();
      return __guard__(_.filter(res.body.results, { name: lookup })[0], (x) =>
        x.values.map((l) => ({ payload: l, text: l }))
      );
    });
  }
};

export default Exim.createStore({
  actions: ['getLookup', 'load', 'loadAll', 'resetCache', 'loadRegionalLookups'],

  getLookup(lookup) {
    return LookupsAPI.get(lookup);
  },

  load(lookup) {
    return LookupsAPI.get(lookup).then((res) => {
      return this.set({ [lookup]: res });
    });
  },

  loadAll() {
    return LookupsAPI.loadAll();
  },

  loadRegionalLookups() {
    // endpoint returns ResponseBase.results, so use the list loader (lazy.item caches `result`)
    return lazy('/api/lookups/regional').then((res) => {
      const results = res?.body?.results;
      if (!results) {
        // lazy() swallows request failures and resolves undefined. These lookups only feed the
        // address autocomplete, so fall back to an empty list (manual entry still works).
        console.error('Error loading regional lookups');
      }
      return this.set({
        regionalLookups: results ?? []
      });
    });
  },

  resetCache() {
    return LookupsAPI.resetCache();
  }
});

export { LookupsAPI as API };

export let AllStore = Exim.createStore({
  actions: ['loadAll'],
  initial: {
    lookups: []
  },

  loadAll() {
    return LookupsAPI.loadAll().then((res) => {
      return this.set({
        lookups: res.body.results
      });
    });
  }
});

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
